import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import { useEffect, useRef, useState } from "react"
import { Box, Button, CircularProgress, FormControlLabel, Link, Modal, Paper, Radio, RadioGroup, Table, TableCell, TableRow, Typography } from '@mui/material';
import IconInfo from '@mui/icons-material/Info';
import IconDelete from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WarningIcon from '@mui/icons-material/Warning';
import ScrapReportDetails from "./scrap-report-details";
import { LinkDetailsClassic } from "./link-details-classic";
import Paginator from "../GeneralComponents/paginator";

export default function ScrapReportsPageClassic(){

    let [infoOpen, setInfoOpen] = useState(false);
    let [selectedInfoScrapReport, setSelectedInfoScrapReport] = useState(null as any);

    let [linkOpen, setLinkOpen] = useState(false);
    let [selectedScrapReportAndLink, setSelectedScrapReportAndLink] = useState({ link: "", scrapReport: null as any});


    function handleCloseInfo(){
        setInfoOpen(false);
    }

    function handleShowInfo(scrapReport: any){
        setSelectedInfoScrapReport(scrapReport);
        setInfoOpen(true);
    }

    function handleLinkClicked(link: string, scrapReport: any){
        setSelectedScrapReportAndLink({ link: link, scrapReport: scrapReport });
        setLinkOpen(true);
    }

    function handleCloseLink(){
        setLinkOpen(false);
    }

    return(
        <>
            <ScrapReportsListClassic handleInfoClick={handleShowInfo} handleOpenClick={handleLinkClicked} />
            <Modal sx={{ left: 100, top: 100, width:9/10 }} open={infoOpen} onClose={handleCloseInfo}>
                { selectedInfoScrapReport ? (
                    <>
                        <Paper elevation = {4} sx={{ padding: 5, paddingBottom: 2}}>
                            <ScrapReportDetails scrapReport={selectedInfoScrapReport} />
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button sx={{ marginLeft: "auto" }} onClick={handleCloseInfo}>Close</Button>
                            </Box>
                        </Paper>
                    </>
                ):(<></>)}
            </Modal>
            <Modal sx={{ left: 100, top: 10, width:9/10 }} open={linkOpen} onClose={handleCloseLink}>
                <Paper sx={{ padding: 5, paddingBottom: 2 }} elevation={4}>
                    <LinkDetailsClassic scrapReport={selectedScrapReportAndLink.scrapReport} link={selectedScrapReportAndLink.link} handleCloseClicked={handleCloseLink} />
                    <Box sx={{ display:'flex', alignItems:'flex-end'}}  >
                        <Button sx={{ marginLeft: "auto" }} onClick={handleCloseLink}>Close</Button>
                    </Box>
                </Paper>
            </Modal>

      </>
    )
}

function NoLinksFound(){
    return (<Typography color="error">No links at all - check scraper</Typography>)
}

function BufferedNewLength({ scrapReport }){
    return (<>
        { scrapReport.bufferedNew.length } buffered links
        { scrapReport.analysisResult?<> - { scrapReport.analysisResult.length } analysed links</>:<></> }
    </>)
}

function ScrapReportLinksCount({ scrapReport }){
    return (
        <>
            <> { new Date(scrapReport.timestamp).toISOString().substring(0, 10) } </>
            <>
                {
                    scrapReport.old == null ? 
                    !scrapReport.linksFound?<NoLinksFound />:<><BufferedNewLength scrapReport={scrapReport}/></>:
                    (scrapReport.old.length + scrapReport.new.length + scrapReport.bufferedNew.length) == 0?<NoLinksFound />:<BufferedNewLength scrapReport={scrapReport}/>
                }
            </>
        </>
    )
}

export function ScrapReportsListClassic({handleInfoClick = (scrapReport) => {}, handleOpenClick = (link, scrapReport) => {}}, handleOpenChiledClicked = (scraper) => {}){

    let [scrapReports, setScrapReports] = useState([] as any[]);
    let [scrapReportsCount, setScrapReportsCount] = useState(0);

    let [linksInStoryline, setLinksInStoryline] = useState([] as string[]);
    let [linksInStorylineReady, setLinksInStorylineReady] = useState(false);

    let [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    let [loading, setLoading] = useState(false);

    let [lastOpenedScraper, setLastOpenedScraper] = useState(null);

    function openScraperTargetInChildWindow(scraper){
        setLastOpenedScraper(scraper);
        window.open(scraper.url, "child");
    }

    function loadList(){

        setScrapReports([]);
        setLoading(true);
        setLinksInStorylineReady(false);

        StorylineServerProxy.getScrapReportsCount().then(count => {  setScrapReportsCount(count.count) });
        StorylineServerProxy.getScrapReports(pageSize, pageNumber).then(scrapReports => { 
            setScrapReports(scrapReports);

            let allLinks = [] as string[];
            for(let scrapReport of scrapReports){
                if(scrapReport.bufferedNew){
                    for(let link of scrapReport.bufferedNew){
                        allLinks.push(link);
                    }
                }
            }
            setLoading(false);

            const allIncludedLinks = [] as string[];
            while(allLinks.length > 0){
                let linksToCheck = allLinks.length > 100?allLinks.splice(0, 100):allLinks;
                StorylineServerProxy.checkLinksUnicity(linksToCheck).then(includedLinks => { allIncludedLinks.push(...includedLinks.links) }); 

            }

            setLinksInStorylineReady(true);
        });
    }

    useEffect(() => {
        loadList();
    }, [pageNumber, pageSize]);


    function handleDeleteClick(scrapReport){
        // NOTE: no confirmation, as this was slowing down the processing
        StorylineServerProxy.markScrapReportAsDeleted(scrapReport._id).then(() => {loadList()});
    }

    function LinkNotAnalysed({ link, scrapReport }){
        return (
            <>
                { linksInStorylineReady?(linksInStoryline.includes(link)?<><WarningIcon/></>:(<></>)):(<CircularProgress size={20}/>) }
                <Link target="child" href={link} onClick={() => { handleOpenClick(link, scrapReport)}}>{ link }</Link>
                <Link href={ link } target="_blank"><OpenInNewIcon /></Link>
                <br/>
            </>
        )
    }

    function ScrapReport({scrapReport, handleOpenChildClicked}){

        const news = [];
        const jobs = [];
        const unrelevant = [];

        if(scrapReport.analysisResult){
            for(const link of scrapReport.analysisResult){
                if(link.isArticle){
                    news.push(link);
                }
                else if(link.isJob){
                    jobs.push(link);
                }
                else{
                    unrelevant.push(link);
                }
            }
        }

        function handleOpenScrapedPagedClicked(){
            handleOpenChildClicked(scrapReport.scraper);
        }

        return (
            <Paper sx={{ padding: 3, marginBottom: 1 }} elevation={4}>
                <b><Link onClick={ handleOpenScrapedPagedClicked } >{ scrapReport.scraper.name }</Link></b>
                <br/>
                <ScrapReportLinksCount scrapReport={ scrapReport }/>
                <br/>
                { scrapReport.errorMessage }
                <br/>
                <IconInfo onClick={() => handleInfoClick(scrapReport)}/>  
                <IconDelete onClick={() => handleDeleteClick(scrapReport)} />
                <br/>
                {
                    scrapReport.bufferedNew?
                        <>
                        {
                            scrapReport.bufferedNew.map(link => {
                                return <LinkNotAnalysed link={link} scrapReport={scrapReport} />
                            })
                        }
                    </>
        :<>Buffered new not available</>
                }
                <Box sx={{ display:'flex', alignItems:'flex-end' }}><IconDelete onClick={() => handleDeleteClick(scrapReport)}  sx={{ marginLeft: "auto" }}></IconDelete></Box>
            </Paper>
        )
    }

    return (
        <>
            <input type="hidden" id="lastOpenedScraper" value={JSON.stringify(lastOpenedScraper)}></input>
            <Paginator pageNumber={pageNumber} pageSize={pageSize} itemsCount={scrapReportsCount} itemType={"scrap reports"} setPageNumber={setPageNumber} setPageSize={setPageSize} />
            <br/>
            {
                loading?<CircularProgress />:<></>
            }
            {
                scrapReports.map(scrapReport => {
                    return <ScrapReport scrapReport={scrapReport}  handleOpenChildClicked={openScraperTargetInChildWindow} />
                })
            }
        </>
    )
}